module.exports = __webpack_public_path__ + "img/map-5.d131037a.svg";